import React from 'react';

const EngagementsSection = () => {
    return (
        <div className="blog-area">
            <div className="container mx-auto py-4 mt-5">
                {/* Main Title */}
                <h2 className="text-4xl font-bold text-center mb-16">
                    <h2 className="our-red-text">Nos engagements envers vous !</h2>
                </h2>

                <div className="flex flex-col lg:flex-row gap-12">
                    {/* Left side with timeline */}
                    <div className="lg:w-1/2">
                        <div className="relative">
                            {/* Timeline vertical line */}
                            <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-white"></div>

                            {/* Item 1 */}
                            <div className="relative mb-12 pl-16">
                                {/* Circle marker */}
                                <div
                                    className="absolute left-0 top-1 w-12 h-12 rounded-full bg-white hover:bg-blue-900-v border-2 border-gray-200 flex items-center justify-center">
                                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                              d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>

                                <h3 className="text-xl font-bold text-blue-800 mb-2">Des procédures simplifiées</h3>
                                <p className="text-gray-600 text-justify">
                                    Chez <i>MesProcédures.fr</i> nous avons une mission : rendre vos démarches
                                    administratives
                                    claires, rapides et sans stress. <br/>De la demande de titre de séjour à la
                                    naturalisation, nous simplifions chaque étape pour que vous n’ayez plus à vous
                                    perdre dans les formalités ou les allers-retours à la préfecture. <br/>Nos experts
                                    prennent en charge les aspects les plus complexes pour vous permettre d’avancer en
                                    toute confiance.</p>
                            </div>

                            {/* Item 2 */}
                            <div className="relative mb-12 pl-16">
                                <div
                                    className="absolute left-0 top-1 w-12 h-12 rounded-full bg-white border-2 border-gray-200 flex items-center justify-center">
                                    <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                              d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>

                                <h3 className="text-xl font-bold text-blue-800 mb-2">Des procédures sur mesure, par
                                    des avocats spécialisés</h3>
                                <p className="text-gray-600 text-justify">
                                    Chaque situation est unique. C’est pourquoi nous vous proposons un accompagnement
                                    100 % personnalisé, assuré par des avocats spécialisés en droit des
                                    étrangers.<br/>Qu’il
                                    s’agisse d’une première demande, d’un renouvellement ou d’un dossier bloqué en
                                    préfecture, nos professionnels sont à vos côtés pour défendre vos droits et
                                    optimiser vos chances de réussite.
                                </p>
                            </div>

                            {/* Item 3 */}
                            <div className="relative mb-12 pl-16">
                                <div
                                    className="absolute left-0 top-1 w-12 h-12 rounded-full bg-blue-900-v flex items-center justify-center">
                                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                              d="M5 13l4 4L19 7"></path>
                                    </svg>
                                </div>

                                <h3 className="text-xl font-bold text-blue-800 mb-2">Des prcoédures lancées rapidement, à un prix imbattable</h3>
                                <p className="text-gray-600 text-justify">
                                    Nos avocats et experts traitent vos demandes avec réactivité et rigueur. Dès la
                                    prise de contact, nous lançons les procédures nécessaires, en tenant compte de votre
                                    situation particulière. <br/>Et parce que nous pensons que l’accès à la régularisation ne
                                    doit pas être un luxe, nous vous offrons les prix les plus compétitifs du marché,
                                    sans compromis sur la qualité.
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Right side with image */}
                    <div className="lg:w-1/2">
                        <div
                            className="bg-blue-900-v rounded-lg p-8 text-white flex flex-col items-center justify-center h-full">
                            <h2 className="text-3xl font-bold text-center mb-8">POURQUOI MES PROCÉDURES ?</h2>

                            <div className="relative w-full py-12 gap-8" >
                                {/* Straight horizontal line */}
                                <div
                                    className="absolute  h-1 bg-white top-1/2 transform translate-y-4 translate-x-10 left-5"
                                    style={{width: "80%"}}></div>

                                {/* Dots and labels */}
                                <div className="grid grid-cols-3 gap-20">
                                    {/* First column */}
                                    <div className="flex flex-col items-center">
                                        <div className="w-8 h-8 bg-white rounded-full border-4 border-blue-900-v flex items-center justify-center z-10">
                                            <div className="w-2 h-2 bg-blue-900-v rounded-full"></div>
                                        </div>
                                        <p className="font-bold text-sm text-center mt-2">PROCÉDURES<br/> SIMPLIFIÉES</p>
                                    </div>

                                    {/* Second column */}
                                    <div className="flex flex-col items-center">
                                        <div className="w-8 h-8 bg-white rounded-full border-4 border-blue-900-v flex items-center justify-center z-10">
                                            <div className="w-2 h-2 bg-blue-900-v rounded-full"></div>
                                        </div>
                                        <p className="font-bold text-sm text-center mt-2">PROCÉDURES<br/>SUR MESURE</p>
                                    </div>

                                    {/* Third column */}
                                    <div className="flex flex-col items-center">
                                        <div className="w-8 h-8 bg-white rounded-full border-4 border-blue-900-v flex items-center justify-center z-10">
                                            <div className="w-2 h-2 bg-blue-900-v rounded-full"></div>
                                        </div>
                                        <p className="font-bold text-sm text-center mt-2">PROCÉDURES<br/> LANCÉES</p>
                                    </div>
                                </div>                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EngagementsSection;